//import Routes
import routesAdmin from './viewRoutes/admin'
import routesHome from './viewRoutes/home'
import routesCrm from './viewRoutes/crm'
import routesService from './viewRoutes/service'
import routesSales from './viewRoutes/sales'
import routesInventory from './viewRoutes/inventory'
import routesPurchases from './viewRoutes/purchases'
import routesBank from './viewRoutes/bank'
import routesProject from './viewRoutes/project'
import routesManufacturing from './viewRoutes/manufacturing'
import routesDocuments from './viewRoutes/documents'
import routesWarehouse from './viewRoutes/warehouse'
import routesAccounting from './viewRoutes/accounting'
import routesStudio from './viewRoutes/studio'

const viewRoutes = [
    ...routesAdmin,
    ...routesHome,
    ...routesCrm,
    ...routesSales,
    ...routesService,
    ...routesInventory,
    ...routesPurchases,
    ...routesBank,
    ...routesProject,
    ...routesManufacturing,
    ...routesDocuments,
    ...routesWarehouse,
    ...routesAccounting,
    ...routesStudio
]

export default viewRoutes;